import type { PropsWithChildren } from "react";
import { Navigate } from "react-router";
import ActoRoutes from "@acto/taskpane/core/router/routes.config";
import { useCustomerWithActivityYears } from "@acto/taskpane/field-sales-2/data-access/useCustomerWithActivityYears";

/**
 * Redirects Home once the customer lookup settles empty, so a deleted customer redirects the same as one outside
 * the viewer's access. A failed lookup is not an empty one and keeps the children.
 */
export function InaccessibleCustomerRedirect({ customerId, children }: PropsWithChildren<{ customerId: string }>) {
  const { data: customer, isFetching, error } = useCustomerWithActivityYears(customerId);

  if (!customer && !isFetching && !error) return <Navigate to={ActoRoutes.HOME} replace />;
  return children;
}
